import { createStore } from 'vuex';
import VuexPersistence from 'vuex-persist'
import state from './state';
import getters from './getters';
import mutations from './mutation';
import actions from './actions';

import user from './user/user-const.js';
import file from './file/file-const';
import auth from './auth/auth-const';
import category from './category/category-const';
import customer from './customer/customer-const';
import employee from './employee/employee-const';
import order from './order/order-const';
import product from './product/product-const';
import supplier from './supplier/supplier-const';
import shipper from './shipper/shipper-const';
import group from './group/group-const';
import usergroup from './userGroup/user-group-const';
const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    key: 'Testek'
})
export const moduleStore = {
    getters,
    state,
    actions,
    mutations,
    namespaced: true,
    modules: {
        user: user,
        category: category,
        file: file,
        auth: auth,
        customer: customer,
        employee: employee,
        order: order,
        product: product,
        supplier: supplier,
        shipper: shipper,
        group: group,
        usergroup: usergroup
    },
    // plugins: [vuexLocal.plugin]
}

export const store = new createStore(moduleStore);